import React, { FC } from 'react';
import { Waiting } from '@/components/Loading';
import styles from './styles/loadingSplash.module.css';

interface ILoadingSplashScreenProps {
  isLoading: boolean;
}

const LoadingSplashScreen: FC<ILoadingSplashScreenProps> = ({ isLoading }) => (
  <div
    className={`z-[99999] flex
                    items-center justify-center page-full
                    ${styles['bg']}
                    ${
                      isLoading
                        ? `${styles['bg-in']}`
                        : `${styles['bg-out']} !pointer-events-none`
                    }`}
  >
    <Waiting />
  </div>
);

export default LoadingSplashScreen;
